import { z } from 'zod'
import { Identity } from '@library/enums'
import { commonDataSchema } from './common-data'
import { dateValueSchema } from './date-value'

/** 企業員工名單 Schema */
export const companyEmployeeSchema = z
  .object({
    /** 會員卡號 */
    memberCardNumber: z.string(),
    /** 身分 */
    identity: z.nativeEnum(Identity),
    /** 英文姓名 */
    englishName: z.string(),
    /** 姓名 */
    name: z.string(),
    /** 部門 */
    department: z.string(),
    /** 驗證[綁定]日期 */
    bindingDate: dateValueSchema
  })
  .merge(commonDataSchema)

/** 企業員工名單 */
export interface CompanyEmployee
  extends z.infer<typeof companyEmployeeSchema> {}
